import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import MiniHeader from '../../../components/layout/MiniHeader/index'
import LoadingIndicator from '../../../components/state/LoadingIndicator'
import ErrorState from '../../../components/state/ErrorState'
import useAppSelector from '../../../state/redux/hooks/index'
import { getAllHelp } from '../../../state/redux/actions/helpAction'
import { clearHelpError } from '../../../state/redux/slices/helpSlice'
import Typography from '../../../components/common/Typography/index'

const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(null)

  const dispatch = useDispatch()

  // Get data from Redux store
  const { allHelp, loading, error } = useAppSelector(state => state.help)

  // FIXED: Extract FAQ data from the response structure
  // Based on your API response, allHelp should contain the array directly
  const faqData = Array.isArray(allHelp) ? allHelp : []

  // Debug: Add console log to see what data structure you're getting
  console.log('allHelp data:', allHelp)
  console.log('faqData:', faqData)

  useEffect(() => {
    // Fetch all help/FAQ items on component mount
    dispatch(getAllHelp())

    // Clear any existing errors
    dispatch(clearHelpError())
  }, [dispatch])

  const toggleQuestion = (questionId) => {
    setOpenQuestion(openQuestion === questionId ? null : questionId)
  }

  return (
    <>
      <MiniHeader title="FAQ Management" activeTab="FAQ" />
      <div className="ml-[250px] p-8 max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="px-6 py-6 border-b border-gray-200 mb-6">
          <div className="flex justify-center items-center">
            <Typography variant="h4" className="text-2xl font-semibold text-gray-900 text-center">
              Frequently Asked Questions
            </Typography>
          </div>
        </div>

        {/* Loading State */}
        {loading && <LoadingIndicator />}

        {/* Error State */}
        {error && !loading && (
          <ErrorState
            error={error}
            onRetry={() => dispatch(getAllHelp())}
          />
        )}

        {/* FAQ Container */}
        {!loading && !error && (
          <div className="bg-gray-100 rounded-lg shadow-sm border overflow-hidden">
            <div className="">
              {faqData && faqData.length > 0 ? (
                faqData.map((faq, index) => (
                  <div key={faq._id || faq.id || index}>
                    {/* FAQ Item */}
                    <div>
                      {/* View Mode Only */}
                      <div className="flex items-center justify-between p-6">
                        <button
                          type="button"
                          onClick={() => toggleQuestion(faq._id || faq.id)}
                          className="flex-1 flex justify-between items-center text-left hover:bg-gray-50 transition-colors duration-200 rounded-lg p-2 -m-2"
                        >
                          <Typography variant="h6" className="text-base font-medium text-gray-900 flex-1 pr-4">
                            {faq.question}
                          </Typography>
                          <div className="flex-shrink-0 text-xl text-gray-500 font-normal">
                            {openQuestion === (faq._id || faq.id) ? "−" : "+"}
                          </div>
                        </button>
                      </div>

                      {openQuestion === (faq._id || faq.id) && (
                        <div className="px-6 pb-6 -mt-2">
                          <Typography variant="body" className="text-gray-700 leading-relaxed text-sm">
                            {faq.answer}
                          </Typography>
                        </div>
                      )}

                      {index < faqData.length - 1 && (
                        <div className="border-b border-gray-200"></div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                // Empty State
                <div className="p-12 text-center">
                  <Typography variant="h6" className="text-gray-500 mb-2">
                    No FAQs Available
                  </Typography>
                  <Typography variant="body" className="text-gray-400">
                    There are currently no frequently asked questions to display.
                  </Typography>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default FAQ